import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  _isLoading = new Subject<boolean>();

  constructor() { }
}
